import { request } from "../utils/request.js"


export const doctorSchedule_exportForManage = (pojo, args) => request({
    url: 'doctorSchedule/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const doctorSchedule_addNew = (pojo, args) => request({
    url: 'doctorSchedule/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const doctorSchedule_findByPageForManage = (pojo, args) => request({
    url: 'doctorSchedule/findByPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const doctorSchedule_time_findByScheduleIdIn = (pojo, args) => request({
    url: 'doctorSchedule/time/findByScheduleIdIn',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    // showSuccessMessage: true,
    ...args
})

export const doctorSchedule_time_changeFrozenStatus = (id, args) => request({
    url: 'doctorSchedule/time/changeFrozenStatus',
    method: 'GET',
    params: {
        id
    },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/doctorSchedule.js